import { setPublicPath } from 'systemjs-webpack-interop';

setPublicPath('landing', 2);
